import styled from 'styled-components';
import {
  List, ListItem, ListItemText as MuiListItemText, MenuItem as MuiMenuItem,
  ListItemIcon as MuiListItemIcon, IconButton, SwipeableDrawer, Divider, Avatar as MuiAvatar
} from '@material-ui/core';
import { Link as RrdLink } from 'react-router-dom';



// Components
// ----------------------------------------------------
export const Logo = styled.img`
  height: 32px;
`;

export const LogoContainer = styled.div`
  width: 100%;
  & img {
    width: 100%;
  }
`;

export const AppBar = styled.div`
  height: 64px;
  position: fixed;
  width: 100vw;
  background: var(--backgroundNavbar);
`;

export const MenuContainer = styled(List)`
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  & .MuiListItem-root {
    width: max-content;
  }

  @media(max-width: 600px) {
    display: none;
  }
`;

export const MenuIcon = styled(IconButton)`
  cursor: pointer;
  display: flex;
  align-items: center;
  color: var(--color-text) !important;
  margin: 0 90px !important;
  min-width: 0;
  width: 78px;
  & span {
    font-size: 3rem !important;
  }
  
  @media(max-width: 959px) {
    margin: 0px !important;
  }
`;

export const DrawerContainer = styled.div`
  width: 214px;
`;

export const DrawerMenu = styled(SwipeableDrawer)`
  & .MuiDrawer-paper {
    background-color: var(--background);
    color: var(--background);
    font-size: 1.6rem;
  }
`;

export const DrawerList = styled(List)`
  & .MuiListItem-root {
    /* background-color: red; */
  }
`;

export const DrawerListItem = styled(ListItem)`
  margin-left: 8px;
  margin-right: 8px;
  border-radius: 4px;

  & .MuiListItemIcon-root {
    min-width: 40px;
    color: var(--black);
  }

  &:hover {
    background: var(--grayLv4);

    & .MuiListItemIcon-root {
      color: var(--black);
    }
    
    & .MuiTypography-body1 {
      color: var(--black);
      font-weight: 500;
    }    
  }
`;

export const MenuListItem = styled(ListItem)`
  & .MuiListItemIcon-root {
    margin: 0 8px;
    border: 1px solid black;
    min-width: 40px;
    color: var(--black);
  }
`;

export const ListItemIcon = styled(MuiListItemIcon)`
  &.MuiListItemIcon-root {
    color: var(--white);
  }
`;

export const ListItemText = styled(MuiListItemText)`
  & .MuiTypography-body1 {
    font-size: 1.4rem
  }
`;

export const DrawerDivider = styled(Divider)`
  &.MuiDivider-root {
    background-color: var(--white);
    margin: 0 8px;
  }
`;

export const DrawerListHeader = styled(List)`
  &.MuiList-root {
    min-width: 100%;
    background: var(--white);
  }

  color: var(--black);
`;

export const DrawerListFooter = styled(List)`
  &.MuiList-root {
    position: absolute;
    bottom: 0;
    min-width: 100%;
    background: var(--white);

    & .MuiButtonBase-root {
      display: flex;
      justify-content: flex-end;
      padding-right: 0;
    }

    & .MuiListItemText-root {
      text-align: right;
      margin-right: 10px;
      font-size: 1.6rem;
    }
  }
`;

export const Avatar = styled(MuiAvatar)``;

export const UserEmail = styled.p`
  margin-top: 1.6rem;
  font-size: 1.4rem;
`;

export const Account = styled.span`
  font-size: 1.4rem;
  color: var(--white);
`;

export const UpdatePasswordLink = styled.a`
  font-size: 1.2rem;
  color: var(--orange);
  margin-top: 1.6rem;
`;

export const FooterLogout = styled.p`
  text-align: center;
  font-size: 1.4rem;
  color: var(--color-text);
`;

export const Link = styled(RrdLink)`
  font-size: 2rem;
  margin-left: 3.8rem;
`;

export const Menu = styled.div`
  display: block;
  position: absolute;
  color: var(--black);
  border-radius: 4px;
  background-color: var(--white);
  min-width: 160px;
  box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);
  padding: 12px 16px;
  z-index: 1;
  top: 40px;
  left: 6px;
  max-width: 280px;
  position: absolute;
`;

export const MenuItem = styled(MuiMenuItem)`
  &.MuiMenuItem-root {
    font-size: 1.4rem;
  }
`;
